import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import {
  agGridOptionsSingle,
  agGridTheme,
  HOST_URL,
  MandatoryExplanation,
  MandatoryFieldIndicator,
} from "../../helpers/constants/Constants.js";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-enterprise";
import Modal from "react-bootstrap/Modal";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import {
  addProjectUser,
  deleteProjectUser,
  getAllProjectUsers,
} from "../../helpers/axios/projectsAxios.js";
import {
  ALL_PROJECT_USERS,
  ALL_ROLES,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer.js";

const Projects = () => {
  const {
    selectedProject,
    allProjectUsers,
    userDetails,
    superUserDetails,
    allRoles,
  } = useSelector((state) => state.globalReducer);
  const [searchCriteria, setSearchCriteria] = useState();
  const [users, setUsers] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const [addUserModal, setAddUserModal] = useState(false);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [gridPageSizeMode, setGridPageSizeMode] = useState("auto");
  // const [listOfSuperUsers, setListOfSuperUsers] = useState([]);
  const dispatch = useDispatch();

  const getRoles = useCallback(() => {
    axios
      .get(HOST_URL + "/forgedata/getRoles", {
        withCredentials: true,
      })
      .then((response) => {
        const sortedData = response.data.sort((a, b) =>
          a.mviewRole.localeCompare(b.mviewRole),
        );
        dispatch(
          updateGlobalState({
            value: sortedData,
            stateName: ALL_ROLES,
          }),
        );
      })
      .catch(console.log);
  }, [dispatch]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const deleteHandler = async (usersToDelete) => {
    await deleteProjectUser(usersToDelete[0], selectedProject[0]);

    refreshAllUsers();
  };

  /////////// AG-GRID STARTING //////////
  const [gridApi, setGridApi] = useState();
  const gridRef = useRef(null);

  const fitGridColumns = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      api.sizeColumnsToFit();
    },
    [gridApi],
  );

  const applyGridPageSizeMode = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      const allRowCount = Math.max(allProjectUsers?.length || 0, 1);

      if (gridPageSizeMode === "all") {
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", allRowCount);
      } else if (gridPageSizeMode === "auto") {
        api.setGridOption("paginationAutoPageSize", true);
      } else {
        const pageSize = Number(gridPageSizeMode) || 25;
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", pageSize);
      }

      api.paginationGoToFirstPage();
    },
    [allProjectUsers, gridApi, gridPageSizeMode],
  );

  useEffect(() => {
    applyGridPageSizeMode();
    fitGridColumns();
  }, [applyGridPageSizeMode, fitGridColumns]);

  const gridReady = (params) => {
    setGridApi(params.api);
    requestAnimationFrame(() => {
      fitGridColumns(params.api);
      applyGridPageSizeMode(params.api);
    });
  };

  const [columnDefs] = useState([
    { field: "id", hide: true },
    { field: "accId", hide: true },
    { field: "projectId", hide: true },
    { field: "name", width: 200 },
    {
      field: "email",
      width: 300,
    },
    {
      field: "role",
      width: 200,
    },
    // {
    //     field: "role",
    //     cellEditor: MultiSelect,
    //     cellEditorPopup: true,
    //     editable: true,
    //     singleClickEdit: true,
    //     cellEditorParams: {
    //       values: UserPermissions.map((role) => {
    //         return role.role;
    //       }),
    //     },
    //     onCellValueChanged: (data) => {
    //       roleChangeHandler(data);
    //     },
    //   },
    // {
    //   field: "role",
    //   width: 200,
    //   cellEditor: singleSelect,
    //   cellEditorPopup: true,
    //   editable: true,
    //   singleClickEdit: true,
    //   cellEditorParams: {
    //     values: allRoles.map((role) => {
    //       return role;
    //     }),
    //   },

    //   onCellValueChanged: (data) => {
    //     roleChangeHandler(data);
    //   },
    // },
    // {
    //   field: "role",
    //   width: 200,
    //   editable: true,
    //   singleClickEdit: true,
    //   cellEditor: "agSelectCellEditor",
    //   cellEditorParams: {
    //     values: allRoles.map((role) => role.mviewRole),
    //   },
    //   onCellValueChanged: (params) => {
    //     roleChangeHandler(params);
    //   },
    // },
    {
      field: "accRole",
      width: 200,
    },
    {
      field: "company",
      width: 200,
    },
    // {
    //   field: "projectAdmin",
    //   headerName: "Project Admin",
    //   editable: true,
    //   cellDataType: "boolean",
    //   width: 200,
    //   onCellValueChanged: (data) => {
    //     sourceChangeHandler(data);
    //   },
    // },
    {
      field: "projectAdmin",
      headerName: "Project Admin",
      //center align the content
      cellStyle: { textAlign: "center" },
      //if true show checkmark if false show x mark
      cellRenderer: (params) =>
        params.value ? (
          <span style={{ color: "green", fontSize: "18px" }}>&#10003;</span>
        ) : (
          <span style={{ color: "red", fontSize: "18px" }}>&#10007;</span>
        ),
    },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      width: 300,
      filter: "agSetColumnFilter",
    }),
    [],
  );

  const selectedDeleteHandler = () => {
    setConfirmDeleteModalOpen(true);
  };

  const confirmDeleteUsers = async () => {
    await deleteHandler(selectedUsers);
    setConfirmDeleteModalOpen(false);
  };

  const fetchUsers = () => {
    // fetch users
    axios({
      method: "get",
      url: HOST_URL + "/forgedata/getAllAccountUsers",
      params: {
        searchCriteria,
      },
      withCredentials: true,
    })
      .then((response) => {
        const sortedData = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
        setUsers(sortedData);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        // refreshAllUsers();
      });
  };

  const userSearchHandler = (e) => {
    setSearchCriteria(e.target.value);
  };

  const userSelector = (e) => {
    setSelectedUser(e.value);
  };
  const roleSelector = (e) => {
    setSelectedRole(e.value);
  };

  const onCloseModal = () => {
    setAddUserModal(false);
    setSelectedUser();
    setSelectedRole();
    setSearchCriteria();
    setUsers();
    setIsAdmin(false);
  };

  const toggleButtonChangeHandler = (e) => {
    setIsAdmin(!isAdmin);
  };

  const selectionChanged = () => {
    setSelectedUsers(gridApi.getSelectedRows());
  };

  const addUserHandler = async (e) => {
    //add user to selected project
    await addProjectUser(
      selectedUser,
      selectedProject[0],
      selectedRole,
      isAdmin,
    );
    onCloseModal();
    refreshAllUsers();
  };

  const refreshAllUsers = async () => {
    const tempAllUsers = await getAllProjectUsers(selectedProject[0].id);
    const sortedData = tempAllUsers?.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ALL_PROJECT_USERS,
      }),
    );
  };

  const canAddUsers = () => {
    let valid = false;
    if (
      (superUserDetails?.admin || userDetails?.projectAdmin) &&
      selectedProject?.length > 0
    ) {
      valid = true;
    }
    return valid;
  };

  return (
    <div className="project-config-page">
      <Container className="project-config-shell">
        {userDetails?.projectAdmin || superUserDetails?.admin ? (
          <>
            {" "}
            <h2 className="project-config-title">Project Admin</h2>
            <div
              className="project-config-actions"
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <Button
                className="project-config-action-btn"
                variant="outline-success"
                size="sm"
                style={{ width: "200px" }}
                onClick={(e) => {
                  setAddUserModal(true);
                }}
                disabled={!canAddUsers()}
              >
                Add user to project
              </Button>
              <Button
                className="project-config-action-btn"
                variant="outline-danger"
                size="sm"
                style={{ width: "200px" }}
                onClick={selectedDeleteHandler}
                disabled={selectedUsers.length === 0}
              >
                Remove user from project
              </Button>
            </div>
            <div className="project-config-grid-row">
              <div className="project-config-grid-wrap">
                <div className="project-config-grid-table">
                  <AgGridReact
                    theme={agGridTheme}
                    ref={gridRef}
                    rowData={allProjectUsers}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    paginationAutoPageSize={gridPageSizeMode === "auto"}
                    paginationPageSizeSelector={false}
                    onSelectionChanged={selectionChanged}
                    stopEditingWhenCellsLoseFocus={true}
                    onGridReady={gridReady}
                    onGridSizeChanged={(params) => {
                      fitGridColumns(params.api);
                      if (gridPageSizeMode === "auto") {
                        applyGridPageSizeMode(params.api);
                      }
                    }}
                    onFirstDataRendered={(params) => {
                      fitGridColumns(params.api);
                      applyGridPageSizeMode(params.api);
                    }}
                    gridOptions={agGridOptionsSingle}
                  />
                  <div className="project-config-grid-rows-view">
                    <Form.Label className="mb-0 me-2">Page size</Form.Label>
                    <Form.Select
                      size="sm"
                      value={gridPageSizeMode}
                      onChange={(e) => {
                        setGridPageSizeMode(e.target.value);
                      }}
                      style={{ maxWidth: "180px" }}
                    >
                      <option value="auto">Auto</option>
                      <option value="25">25 per page</option>
                      <option value="50">50 per page</option>
                      <option value="100">100 per page</option>
                      <option value="all">All (scroll)</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="alert alert-danger" role="alert">
            You do not have permission to view this page. Please contact your
            administrator.
          </div>
        )}
      </Container>

      {/* MODALS */}
      <Modal
        show={addUserModal}
        onHide={onCloseModal}
        dialogClassName="add-user-modal project-config-modal"
        centered
      >
        <Modal.Header className="project-config-modal__header">
          <Modal.Title>Add user to project</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onCloseModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-config-modal__body">
          <label>
            Enter user's name or email
            <MandatoryFieldIndicator />
          </label>
          <div className="input-group mb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Enter user's name or email"
              aria-label="Recipient's username"
              aria-describedby="button-addon2"
              onChange={userSearchHandler}
              value={searchCriteria}
            />
            <button
              className="btn btn-outline-success"
              type="button"
              id="button-addon2"
              onClick={fetchUsers}
            >
              Search
            </button>
          </div>
          {users && (
            <>
              <label>
                Please select a user from the list
                <MandatoryFieldIndicator />
              </label>
              {/* <div className="input-group mb-2"> */}
              <Select
                className="basic-single mb-2"
                classNamePrefix="project-config-select"
                placeholder="Please select a user to add"
                menuPortalTarget={document.body}
                options={users?.map((user) => {
                  return {
                    value: user,
                    label: `${user.name} (${user.email})`,
                  };
                })}
                isSearchable={true}
                onChange={userSelector}
                value={{
                  value: selectedUser,
                  label: selectedUser?.name,
                }}
              />
              {/* </div> */}
            </>
          )}
          {selectedUser && (
            <>
              <label>
                What role is this user?
                <MandatoryFieldIndicator />
              </label>
              <Select
                className="basic-single mb-2"
                classNamePrefix="project-config-select"
                placeholder="Please select a role"
                menuPortalTarget={document.body}
                options={allRoles?.map((role) => {
                  return {
                    value: role,
                    label: role.mviewRole,
                  };
                })}
                isSearchable={true}
                onChange={roleSelector}
                value={{
                  value: selectedRole,
                  label: selectedRole?.mviewRole,
                }}
              />
            </>
          )}
          {selectedRole &&
            (superUserDetails?.admin ||
              userDetails?.role === "Design Manager") && (
              <div className="row">
                <ButtonGroup className=" mt-1 mb-2">
                  <ToggleButton
                    id="isAdmin"
                    type="checkbox"
                    variant="outline-success"
                    checked={isAdmin}
                    // value={selectedMarkup?.id}
                    onChange={(e) => toggleButtonChangeHandler(e)}
                  >
                    Is Project Admin?
                  </ToggleButton>
                </ButtonGroup>
              </div>
            )}

          <ButtonGroup className="mt-1">
            <Button
              variant="outline-success"
              // size="sm"
              style={{ width: "150px" }}
              onClick={addUserHandler}
              disabled={!selectedUser}
            >
              Add User
            </Button>
          </ButtonGroup>
          <MandatoryExplanation />
        </Modal.Body>
      </Modal>

      <Modal
        show={confirmDeleteModalOpen}
        onHide={() => setConfirmDeleteModalOpen(false)}
        dialogClassName="project-info-modal app-confirm-modal"
        centered
      >
        <Modal.Header className="project-info-modal__header app-confirm-modal__header">
          <Modal.Title>Remove Selected User(s)?</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={() => setConfirmDeleteModalOpen(false)}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-info-modal__body app-confirm-modal__body">
          <p className="app-confirm-modal__copy">
            Are you sure you want to remove the selected user(s) from this
            project?
          </p>
          <div className="app-confirm-modal__actions">
            <button
              type="button"
              className="btn btn-outline-danger project-status-modal__action-btn"
              onClick={() => setConfirmDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-outline-success project-status-modal__action-btn"
              onClick={confirmDeleteUsers}
            >
              Remove User(s)
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Projects;
